export interface InvoiceFormModel {
    name: string;
    idNumber: string;
    vatNumber?: string;
    country: string;
    region: string;
    city: string;
    postalCode: number;
    address: string;
    phoneNumber?: string;
    buyerName?: string;
    email?: string;
    notes?: string;
}

export class InvoiceFormClass implements InvoiceFormModel {
    name;
    idNumber;
    vatNumber;
    country;
    region;
    city;
    postalCode;
    address;
}

export interface ILegalPerson {
    isLegal: boolean;
    idNumber: string;
    idType: string;
    custodianOfProperty: string;
    name: string;
    middleName: string;
    familyName: string;
    country: string;
    city: string;
    address: string;
    phone: string;
    postalCode?: number;
    email?: string;
    vatIdNumber?: string;
}

export class BuyerClass implements ILegalPerson {
    isLegal;
    idType;
    idNumber;
    custodianOfProperty;
    name;
    middleName;
    familyName;
    country;
    city;
    address;
    phone;
    postalCode;
    email;
    vatIdNumber;
}
